<template>
  <div class="shicigame-layout">
    <div class="layout-header">
      <div class="header-content">
        <div class="header-left">
          <h1 class="site-title">诗词游戏</h1>
          <nav class="nav-menu">
            <router-link to="/shicigame" class="nav-link" :class="{ active: $route.path === '/shicigame' }">
              游戏
            </router-link>
            <router-link to="/shicibackup" class="nav-link" :class="{ active: $route.path === '/shicibackup' }">
              背书
            </router-link>
            <router-link v-if="isAdmin" to="/shicifetch" class="nav-link" :class="{ active: $route.path === '/shicifetch' }">
              诗词抓取
            </router-link>
            <router-link v-if="isAdmin" to="/manager/users" class="nav-link" :class="{ active: $route.path.indexOf('/manager') === 0 }">
              后台管理
            </router-link>
          </nav>
        </div>
        <div class="header-right">
          <div v-if="username" class="user-info">
            <span class="username">{{ username }}</span>
            <el-button type="danger" size="small" @click="handleLogout" class="logout-btn">退出</el-button>
          </div>
          <router-link v-else to="/shicilogin" class="login-link">登录</router-link>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShiciGameLayout',
  data() {
    return {
      username: '',
      isAdmin: false
    }
  },
  mounted() {
    this.refreshUser()
    window.addEventListener('shicigame-auth-changed', this.refreshUser, false)
  },
  beforeDestroy() {
    window.removeEventListener('shicigame-auth-changed', this.refreshUser, false)
  },
  methods: {
    refreshUser() {
      try {
        const user = JSON.parse(localStorage.getItem('shicigame_user') || '{}') || {}
        this.username = user.username || ''
        this.isAdmin = user.role === 'admin'
      } catch (e) {
        this.username = ''
        this.isAdmin = false
      }
    },
    handleLogout() {
      localStorage.removeItem('shicigame_token')
      localStorage.removeItem('shicigame_user')
      this.username = ''
      this.isAdmin = false
      window.dispatchEvent(new Event('shicigame-auth-changed'))
      this.$router.push('/shicilogin')
    }
  }
}
</script>

<style scoped>
.shicigame-layout {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.layout-header {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 30px;
  flex: 1;
}

.site-title {
  font-size: 24px;
  font-weight: 600;
  color: #667eea;
  margin: 0;
  letter-spacing: 2px;
  white-space: nowrap;
}

.nav-menu {
  display: flex;
  gap: 20px;
  flex: 1;
  justify-content: center;
}

.nav-link {
  text-decoration: none;
  color: #606266;
  font-size: 16px;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.nav-link:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.nav-link.active {
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header-right {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.username {
  color: #303133;
  font-weight: 500;
  font-size: 14px;
}

.logout-btn {
  padding: 8px 16px;
  border-radius: 20px;
}

.login-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border: 2px solid #667eea;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.login-link:hover {
  background: #667eea;
  color: white;
}

.layout-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    height: auto;
    padding: 15px 20px;
    gap: 15px;
  }
  
  .header-left {
    flex-direction: column;
    gap: 15px;
    width: 100%;
    align-items: center;
  }
  
  .site-title {
    font-size: 20px;
    text-align: center;
  }
  
  .nav-menu {
    width: 100%;
    justify-content: center;
    gap: 10px;
  }
  
  .nav-link {
    font-size: 14px;
    padding: 6px 12px;
  }
  
  .header-right {
    width: 100%;
    justify-content: center;
  }
  
  .user-info {
    gap: 10px;
  }
  
  .username {
    font-size: 12px;
  }
  
  .logout-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .login-link {
    font-size: 12px;
    padding: 6px 12px;
  }
  
  .layout-content {
    padding: 20px 15px;
  }
}

@media (max-width: 480px) {
  .nav-menu {
    flex-wrap: wrap;
  }
  
  .nav-link {
    font-size: 12px;
    padding: 4px 8px;
  }
  
  .site-title {
    font-size: 18px;
  }
  
  .header-content {
    padding: 10px 15px;
    gap: 10px;
  }
  
  .layout-content {
    padding: 15px 10px;
  }
}
</style>
